export const AircraftType = {
    A310: 'a31',
    B744: '744',
    B743: '743'
}